module.exports = __webpack_public_path__ + "img/lt-icone-email-violet.430a2d43.svg";